<template>
  <div v-if="!isLogin" class="mt-4" />
  <div v-else class="mt-4">
    <div
      v-for="problem in bookmarkPresenter.bookmark.value.problems"
      :key="problem.id"
      class="hover-hand border rounded my-1 flex items-center p-4 hover:shadow transition duration-100 hover:border-bookmark text-gray-900 dark:hover:border-bookmark-dark dark:border-dark-400 dark:text-dark-text dark:bg-dark-500"
      @click="clickProblem(problem.id)"
    >
      <span class="material-icons mr-4">
        <span v-if="problem.isSolved" class="text-bookmark dark:text-bookmark-dark"> check_circle </span>
        <span v-else class="text-gray-500 dark:text-dark-text"> radio_button_unchecked </span>
      </span>
      <p class="text-lg font-bold">{{ problem.id }} : {{ problem.name }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { useAuthStatePresenter } from '@/presentation/composables/auth/useAuthStatePresenter'
import { useBookmarkPresenter } from '@/presentation/composables/bookmark/useBookmarkPresenter'

export default defineComponent({
  components: {},
  props: {
    onClickBookmark: {
      type: Function,
      required: true
    }
  },
  setup(props, ctx) {
    const { isLogin } = useAuthStatePresenter()
    const bookmarkPresenter = useBookmarkPresenter()
    const clickProblem = (id: string) => {
      props.onClickBookmark(id)
    }
    return { clickProblem, bookmarkPresenter, isLogin }
  }
})
</script>

<style lang="postcss" scoped></style>
